import YYRadio from './radio'
import YYRadioGroup from './radio-group'

YYRadio.YYRadioGroup = YYRadioGroup
export default YYRadio